export enum OpenCloseType {
  OPEN,
  CLOSE,
}
